// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ju-0";
export var buttonContainer = "_ju-3";
export var cancelButton = "_ju-4";
export var headerSection = "_ju-6";
export var headerTitle = "_ju-9";
export var messageSideLeft = "_ju-1";
export var messageSideRight = "_ju-2";
export var orderNumberContainer = "_ju-7";
export var orderNumberLabel = "_ju-8";
export var submitButton = "_ju-5";